export default function PageTitle({ title }) {
	return <h1 className="text-appBlack font-bold p-6 text-[30px]">{title}</h1>;
}
